module.exports = __webpack_public_path__ + "img/file-earmark-medical.35d95567.svg";